import Api from './api'

export default class extends Api {

    constructor() {
        super()

        this.storagePrefix = 'search_'
    }

    /**
     * getProfessionals
     *
     * @param professionalId ID of professional
     * @param params URL params
     * @returns {Promise.<*>}
     */
    async getProfessionals (params) {
        try {
            const response = await this.get('/api/professionals', params, false, false, (60 * 60) * 24)

            return response
        } catch (error) {
            throw error
        }
    }

    async getProfessionalMapMarkers (params) {
        try {
            const response = await this.post('/api/professionals/map-markers', params)

            return response
        } catch (error) {
            throw error
        }
    }

}


// WEBPACK FOOTER //
// ./application/assets/js/site/api/search.js